import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiPopover, EuiToolTip } from "@elastic/eui";
import React, {useState, useMemo} from "react";
import { Action } from "../../../../ui/src/components/Menus/interface";

export const ButtonGroup = (props:any) =>{
    const {buttons} = props;

    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const onButtonClick = () => setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
    const closePopover = () => setIsPopoverOpen(false);

    const onClick = (handle?:()=> void)=>{handle && handle();closePopover();}    

    const getButtons = useMemo(() =>{
        return buttons.slice(1,buttons.length).map((b:Action)=>{
            return (
                <EuiFlexItem>
                    <EuiButton size={b.size} fill color={b.color} isDisabled={b.isDisabled}
                        onClick={()=> {onClick(b.handle)}} className={b.className ? b.className : "menuButton"}>
                        {b.text}
                    </EuiButton>
                </EuiFlexItem>
            )
        })
    },[buttons])

    const principalButton = useMemo(() =>{
        const btn:Action = buttons[0];

        return (
        <EuiButton className='menuButton' size='s' iconType="arrowDown" iconSide="right" onClick={onButtonClick} fill style={{borderRadius:'0px'}}>
        {btn.text}
        </EuiButton>
        )
    },[buttons])

    return (
        <EuiPopover
        ownFocus={false}
        button={principalButton}
        isOpen={isPopoverOpen}
        closePopover={closePopover}
        initialFocus="[id=asdf2]">
        <EuiFlexGroup direction='column' gutterSize='s'>
        {getButtons}
        </EuiFlexGroup>
        </EuiPopover>
    )
    
}